import React from "react";
import { useTranslation } from "react-i18next";
import SFButton from "../../button";
import { SFAddIcon } from "../../icons";

const AddGroup = (props) => {
  const { t } = useTranslation();
  if (props.disableGroup)
    return null;
  return (
    <SFButton
      variant="secondary"
      onClick={props.handleOnClick}
    >
      <SFAddIcon size="xsmall" />
      {t("components.queryBuilder.groupLabel")}
    </SFButton>
  );
};

export default AddGroup;
